import { useState, memo } from 'react';
import { Link } from 'react-router-dom';
import { apiForgotPassword } from '../api/auth';
import { ApiError } from '../api/client';

export default memo(function ForgotPasswordPage() {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    apiForgotPassword({ email })
      .then(() => setSent(true))
      .catch((err: unknown) => {
        setError(
          err instanceof ApiError && err.status === 429
            ? 'Too many requests — please wait 15 minutes'
            : 'Something went wrong — please try again',
        );
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="auth-page">
      <div className="auth-header">
        <h1 className="auth-title">forgot password</h1>
        <p className="auth-subtitle">
          We'll send a reset link to your email.
        </p>
      </div>

      {sent ? (
        <>
          <div className="tfa-success-banner" role="status">
            <span className="tfa-success-icon">✓</span>
            If that email is registered, a reset link has been sent.
          </div>
          <p className="verify-email-note" style={{ marginTop: '1rem' }}>
            Check your spam folder if it doesn't arrive within a minute.
            The link expires in <strong>1 hour</strong>.
          </p>
          <p className="auth-footer">
            <Link to="/login">← back to sign in</Link>
          </p>
        </>
      ) : (
        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <div className="form-field">
            <label className="form-label" htmlFor="forgot-email">email</label>
            <input
              id="forgot-email"
              className="form-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              autoFocus
            />
          </div>

          {error && <div className="form-server-error" role="alert">{error}</div>}

          <button
            className="btn btn--primary auth-submit-btn"
            type="submit"
            disabled={loading || !email}
          >
            {loading ? (
              <span className="auth-btn-loading">
                <span className="auth-spinner" />
                sending…
              </span>
            ) : (
              'send reset link'
            )}
          </button>
        </form>
      )}

      {!sent && (
        <p className="auth-footer">
          remembered it? <Link to="/login">sign in</Link>
        </p>
      )}
    </div>
  );
});
